import type { BenefitInputs, RuleSetRecord, RulesEngineRunValidation } from '../types/rulesEngine'
import { getRuleSetRulesCount } from '../services/rulesEngineService'

type ValidateRunInput = {
  selectedPatientId: string
  selectedRuleSet: RuleSetRecord | null
  autoPopulated: boolean
  isLoadingBenefits: boolean
  benefits: BenefitInputs
  /** When true, patient is already known from the page context (e.g. Patient Detail). */
  patientPreSelected?: boolean
  /** Field keys required by the selected rule set. Empty until a rule set is loaded. */
  requiredFieldKeys?: string[]
  isLoadingRuleSet?: boolean
}

export function validateRulesEngineRun(input: ValidateRunInput): RulesEngineRunValidation {
  const {
    selectedPatientId,
    selectedRuleSet,
    autoPopulated,
    isLoadingBenefits,
    benefits,
    patientPreSelected = false,
    requiredFieldKeys = [],
    isLoadingRuleSet = false,
  } = input

  let patient: string | null = null
  let ruleSet: string | null = null
  let rules: string | null = null
  let benefitsError: string | null = null

  if (!patientPreSelected && !selectedPatientId.trim()) {
    patient = 'Select a patient from the saved Patients list before running.'
  }

  if (!selectedRuleSet) {
    ruleSet = 'Select a rule set to evaluate.'
  } else if (isLoadingRuleSet) {
    rules = `Loading rules for “${selectedRuleSet.name}”.`
  } else if (getRuleSetRulesCount(selectedRuleSet) === 0) {
    rules = `“${selectedRuleSet.name}” has no rules. Add rules on the Rules Engine page first.`
  }

  if (!selectedRuleSet) {
    benefitsError = null
  } else if (isLoadingBenefits) {
    benefitsError = 'Patient values are still loading.'
  } else if (isLoadingRuleSet) {
    benefitsError = 'Rule set fields are still loading.'
  } else {
    benefitsError = null
  }

  const valid = !patient && !ruleSet && !rules && !benefitsError

  return {
    valid,
    patient,
    ruleSet,
    rules,
    benefits: benefitsError,
  }
}
